import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import * as d3 from 'd3';

@Component({
    name: 'cross-walk-popup',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class CrossWalkPopup extends Vue {

    // -------------------------------------------------------------------------------
    // Properties
    @Prop()
    private tableData: any;

    @Prop()
    private category: any;

    @Prop()
    private subject: any;

    private isToggleMicroCompetency: boolean = true;

    private get subjectTitle() {
        return this.subject.title;
    }

    // ----------------------------------------------------------------------
    // Actions
    private scrollTop() {
        this.$emit('scrollTop');
    }

    // private onClickSearchIcon(header: any, headerIndex: number) {

    // }

    private onToggleMicroCompetency() {
        this.isToggleMicroCompetency = !this.isToggleMicroCompetency;
        d3.selectAll('.micro-competency').classed('hide-row', this.isToggleMicroCompetency);
    }
}
